<template>
  <b-field :label="$t('catalogue.newProduct.azimut')">
    <b-autocomplete
        ref="autocomplete"
        v-model="azimut"
        :data="listeAzimut"
        :open-on-focus="true"
        @select="selectAzimut"
        @typing="typingAzimut"
        field="code"
        expanded
        :disabled="isSynchro">
        <template slot="empty">
          {{$t('general.autocomplete.noRslt')}}
        </template>
        <template slot-scope="props">
          <div class="media is-align-items-center">
            <div class="media-left azimut mgr-2">
              <div :class="props.option.class"></div>
            </div>
            <div class="media-content">
              {{ props.option.code }}°
            </div>
          </div>
        </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { LISTE_AZIMUT_RECHERCHE } from '@/configuration/catalogue/produitConf';

export default {
  props: ['value', 'isSynchro'],
  data() {
    return {
      azimut: null,
      listeAzimut: LISTE_AZIMUT_RECHERCHE,
    };
  },
  methods: {
    selectAzimut(option) {
      if (option) {
        const az = parseInt(option.code, 10);
        this.azimut = az;
        this.$emit('input', az);
      }
    },
    typingAzimut(e) {
      if (!e) this.$emit('input', null);
      else this.$emit('input', parseInt(e, 10));
    },
  },
  mounted() {
    this.azimut = this.value;
  },
};
</script>

<style>

</style>
